import React from "react";
import "../LoadingPage/style.scss";

const LoadingPage = () => {
  return (
    <div className="loading-page">
      <div className="loading-container">
        <div className="loader"></div>
      </div>
    </div>
  );
};

export default LoadingPage;
